<div class="sera-range-slider__container">
    <label
        *ngIf="label"
        [for]="inputId">
        {{ label | translate }}
    </label>
    <span *ngIf="displayMinAndMax">{{ min }}</span>
    <p-slider
        [ngClass]="[colorClass, displayMinAndMax ? 'sera-range-slider__container--with-margin' : 'sera-range-slider__container--no-margin']"
        [ngModel]="value"
        (onChange)="onSlideChangeFn($event)"
        (onSlideEnd)="onSlideEndFn($event)"
        [disabled]="isDisabled || isReadOnly"
        [min]="min"
        [max]="max"
        [step]="1" />
    <span *ngIf="displayMinAndMax">{{ max }}</span>
</div>
